// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { CostReviewStatus } from '../Enums/CostReviewStatus';
export class CostReviewerDetails {
  reviewerTypeID: number;
  reviewerName: string;
  reviewerEmail: string;
  reviewUserId: string;
  requiredBy: Date | null;
  closeDate: Date | null;
  reviewerStatus: CostReviewStatus;
  reviewerComments: string;
  modifiedBy: string;
  originalReviewerId: string;
  reviewerType: string;
  originalReviewerName: string;
  isOriginalReviewerVisible: boolean;
  isPolicyMandatedApprover: boolean;
}
